var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flip-countdown',{attrs:{"deadline":_vm.deadline}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }